// Copyright (c) 2017 Deere & Company

import {
    amountOfUseItemToUpdate,
    commentsToDealerUpdate,
    internalDeereCommentsUpdate
} from './amount-of-use-item-to-update';
import {
    closeAmountOfUseModal,
    openAmountOfUseModal
} from './update-amount-of-use-modal';
import {
    closeMachineStatusModal,
    openMachineStatusModal
} from './machine-status-modal';
import {
    closePipCodeRequestModal,
    openPipCodeRequestModal
} from './pip-code-request-modal';
import {
    exportMachineStatusUpdates,
    readMachineStatusUpdates
} from './get-machine-status-updates';
import {
    exportPipCodeRequests,
    readPipCodeRequests
} from './get-pip-code-requests';
import {
    exportSpaClaims,
    readSpaClaims
} from './get-spa-claims';
import {
    machineStatusItemToUpdate,
    updateCommentsToDealer,
    updateInternalDeereComments
} from './machine-status-item-to-update';
import {
    onSearch,
    updateSearchByDropDown,
    updateSearchQueryString
} from './search';
import {
    pipCodeRequestItemToUpdate,
    updatePipCodeRequestTcsmComments
} from './pip-code-request-item-to-update';
import {
    readTcsmSettings,
    resetTcsmSettingsFacet,
    toggleSpaLevelsListItems,
    updateSelectedSpaLevelsList
} from './tcsm-settings';
import {
    resetWipFacets,
    updateWipFacets
} from './wip-facets';
import {
    updateAmountOfUseRequestListFilterBy,
    updateAmountOfUseRequestListSortBy,
    updateAmountOfUseRequestListSortDirection
} from './amount-of-use-request-search-filters';
import {
    updateClosingAccountListFilterBy,
    updateClosingAccountListSortBy,
    updateClosingAccountListSortDirection
} from './closing-account-search-filters';
import {
    updateDuplicatePinPlateListFilterBy,
    updateDuplicatePinPlateListSortBy,
    updateDuplicatePinPlateListSortDirection
} from './duplicate-pin-plate-search-filters';
import {
    updateLaborRateChangesListFilterBy,
    updateLaborRateChangesListSortBy,
    updateLaborRateChangesListSortDirection
} from './labor-rate-changes-search-filters';
import {
    updateMachineStatusListFilterBy,
    updateMachineStatusListSortBy,
    updateMachineStatusListSortDirection
} from './machine-status-search-filters';
import {
    updatePipCodeRequestListFilterBy,
    updatePipCodeRequestListSortBy,
    updatePipCodeRequestListSortDirection
} from './pip-code-request-search-filters';
import {
    updateSpaClaimsListFilterBy,
    updateSpaClaimsListSortBy,
    updateSpaClaimsListSortDirection
} from './spa-claims-search-filters';
import {acceptClosingAccount} from './put-close-account';
import {approveDenyAmountOfUse} from './approve-deny-amount-of-use';
import {approveDenyMachineStatus} from './approve-deny-machine-status';
import {approveDenyPipCodeRequest} from './approve-deny-pip-code-request';
import {readAmountOfUseRequests} from './get-amount-of-use-requests';
import {readAuditCount} from './get-audit-count';
import {readClosingAccount} from './get-close-account';
import {readDealer} from './read-dealer';
import {readDuplicatePinPlate} from './get-duplicate-pin-plate';
import {readLaborRateChanges} from './get-labor-rate-changes';
import {readTerritories} from './get-territories';
import {resetNewTransfer} from './reset-new-transfer';
import {toggleReportsAccordion} from '../../shared/action-creators/reports-accordion';
import {updateCloseAccountIndex} from './close-account-index';
import {updateDealerSearchModalVisibility} from '../../../product/new-transfer/action-creators/dealer-search-modal';
import {updateDuplicatePinPlateStatus} from './put-duplicate-pin-plate';
import {updateFacetFilterText} from './facet-filter-text';
import {updateFilteredTerritories} from './filtered-territories';
import {updateInitialLoad} from './is-initial-load';
import {updateOverrideAccount} from './update-override-close-account';

export default {
    acceptClosingAccount,
    amountOfUseItemToUpdate,
    approveDenyAmountOfUse,
    approveDenyMachineStatus,
    approveDenyPipCodeRequest,
    closeAmountOfUseModal,
    closeMachineStatusModal,
    closePipCodeRequestModal,
    commentsToDealerUpdate,
    exportMachineStatusUpdates,
    exportPipCodeRequests,
    exportSpaClaims,
    internalDeereCommentsUpdate,
    machineStatusItemToUpdate,
    onSearch,
    openAmountOfUseModal,
    openMachineStatusModal,
    openPipCodeRequestModal,
    pipCodeRequestItemToUpdate,
    readAmountOfUseRequests,
    readAuditCount,
    readClosingAccount,
    readDealer,
    readDuplicatePinPlate,
    readLaborRateChanges,
    readMachineStatusUpdates,
    readPipCodeRequests,
    readSpaClaims,
    readTcsmSettings,
    readTerritories,
    resetNewTransfer,
    resetTcsmSettingsFacet,
    resetWipFacets,
    toggleReportsAccordion,
    toggleSpaLevelsListItems,
    updateAmountOfUseRequestListFilterBy,
    updateAmountOfUseRequestListSortBy,
    updateAmountOfUseRequestListSortDirection,
    updateCloseAccountIndex,
    updateClosingAccountListFilterBy,
    updateClosingAccountListSortBy,
    updateClosingAccountListSortDirection,
    updateCommentsToDealer,
    updateDealerSearchModalVisibility,
    updateDuplicatePinPlateListFilterBy,
    updateDuplicatePinPlateListSortBy,
    updateDuplicatePinPlateListSortDirection,
    updateDuplicatePinPlateStatus,
    updateFacetFilterText,
    updateFilteredTerritories,
    updateInitialLoad,
    updateInternalDeereComments,
    updateLaborRateChangesListFilterBy,
    updateLaborRateChangesListSortBy,
    updateLaborRateChangesListSortDirection,
    updateMachineStatusListFilterBy,
    updateMachineStatusListSortBy,
    updateMachineStatusListSortDirection,
    updateOverrideAccount,
    updatePipCodeRequestListFilterBy,
    updatePipCodeRequestListSortBy,
    updatePipCodeRequestListSortDirection,
    updatePipCodeRequestTcsmComments,
    updateSearchByDropDown,
    updateSearchQueryString,
    updateSelectedSpaLevelsList,
    updateSpaClaimsListFilterBy,
    updateSpaClaimsListSortBy,
    updateSpaClaimsListSortDirection,
    updateWipFacets
};



// WEBPACK FOOTER //
// ./src/tcsm/wip/action-creators/index.js